import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useMemo, useState } from 'react';
import * as _ from 'lodash';
import { useQuery } from 'react-query';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { toGreeklish, toGreek } from 'greek-utils';
import axiosClient from 'http/axios-client';

const DoctorSearchForm = (props) => {
  const [ search, setSearch ] = useState('');

  const searchQuery = useMemo(() => {
    const defaultParams = {
      _limit: -1,
      _sort: 'family_name:asc,name:asc',
      verification_status: 'VERIFIED',
    };

    const trimmedSearch = search.trim();

    if ('' === trimmedSearch) {
      return defaultParams;
    }

    const searchTokens = trimmedSearch
      .split(' ')
      .map((t) => { return t.trim(); })
      .filter((s) => { return '' !== s; });

    if (0 === searchTokens.length) {
      return defaultParams;
    }

    if (1 === searchTokens.length) {
      const [ f ] = searchTokens;

      let enF = '';
      let elF = '';

      if (f.match(/[a-z]/i)) {
        enF = f;
        elF = toGreek(f);
      } else {
        enF = toGreeklish(f);
        elF = f;
      }

      return {
        ...defaultParams,
        _where: {
          _or: [
            [{ name_contains: enF }],
            [{ name_contains: elF }],

            [{ family_name_contains: enF }],
            [{ family_name_contains: elF }],

            [{ brand_name_contains: enF }],
            [{ brand_name_contains: elF }],

            [{ specialty_contains: enF }],
            [{ specialty_contains: elF }],
          ],
        },
      };
    }

    if (2 === searchTokens.length) {
      // assume the user has written firstName and lastName
      const [ f, l ] = searchTokens;
      const all = searchTokens.join(' ');

      let enF = '';
      let elF = '';

      let enL = '';
      let elL = '';

      let enAll = '';
      let elAll = '';

      if (f.match(/[a-z]/i)) {
        enF = f;
        elF = toGreek(f);

        enL = l;
        elL = toGreek(l);

        enAll = all;
        elAll = toGreek(all);
      } else {
        enF = toGreeklish(f);
        elF = f;

        enL = toGreeklish(l);
        elL = l;

        enAll = toGreeklish(all);
        elAll = all;
      }

      return {
        ...defaultParams,
        _where: {
          _or: [
            [{ name_contains: enF, family_name_contains: enL }],
            [{ name_contains: elF, family_name_contains: elL }],

            [{ name_contains: enL, family_name_contains: enF }],
            [{ name_contains: elL, family_name_contains: elF }],

            [{ brand_name_contains: enAll }],
            [{ brand_name_contains: elAll }],
          ],
        },
      };
    }

    if (2 < searchTokens.length) {
      const all = searchTokens.join(' ');

      let enAll = '';
      let elAll = '';

      if (all.match(/[a-z]/i)) {
        enAll = all;
        elAll = toGreek(all);
      } else {
        enAll = toGreeklish(all);
        elAll = all;
      }

      return {
        ...defaultParams,
        _where: {
          _or: [
            [{ brand_name_contains: enAll }],
            [{ brand_name_contains: elAll }],
          ],
        },
      };
    }

    return {
      _limit: 0,
    };
  }, [ search ]);

  const {
    data: options,
    isLoading,
    isFetching,
  } = useQuery(
    [ 'doctors', { search, searchQuery, country: props.country }],
    () => {
      if (props.country) {
        return axiosClient.get('doctors', { params: { ...searchQuery, country_eq: props.country } });
      }

      return axiosClient.get('doctors', { params: { ...searchQuery } });
    },
  );

  const loading = isLoading || isFetching;

  const [ value, setValue ] = useState(null);

  return (
    <form
      noValidate
      style={ { width: '100%' } }
    >
      <Grid container spacing={ 2 }>
        <Grid item xs={ 12 }>
          <Grid container spacing={ 1 }>
            <Grid item xs={ 12 }>
              <Autocomplete
                filterOptions={ (opts) => {
                  return opts;
                } }
                getOptionSelected={ (option, v) => {
                  return option.id === v.id;
                } }
                renderOption={ (option) => {
                  return (
                    <Grid container>
                      <Grid item xs={ 12 }>
                        <Typography variant='subtitle1'>
                          { `${ option.family_name }, ${ option.name }` }
                        </Typography>
                      </Grid>
                      {
                        null != option.brand_name && '' !== option.brand_name
                        && (
                          <Grid item xs={ 12 }>
                            <Typography variant='subtitle1'>
                              { `${ 'Company name' }: ${ option.brand_name }` }
                            </Typography>
                          </Grid>
                        )
                      }
                      <Grid item xs={ 12 }>
                        <Typography variant='subtitle1'>
                          { `${ 'Specialty' }:  ${ option.specialty }` }
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                } }
                getOptionLabel={ (option) => {
                  return `${ option.family_name } ${ option.name }` || '';
                } }
                options={ options || [] }
                value={ value }
                loading={ loading }
                onChange={ (event, newValue) => {
                  const copy = _.cloneDeep(newValue);
                  if (null != copy && null == copy.brand_name) {
                    copy.brand_name = '';
                  }

                  setValue(copy);
                  props.func(copy);
                } }
                inputValue={ search }
                onInputChange={ (e, newValue, reason) => {
                  if ('' === newValue && 'reset' === reason) {
                    return;
                  }
                  setSearch(newValue);
                } }
                renderInput={ (params) => {
                  return (
                    <Grid container>
                      <TextField
                        variant='outlined'
                        color='secondary'
                        size='small'
                        margin='dense'
                        { ...params }
                      />
                    </Grid>
                  );
                } }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default DoctorSearchForm;
